// Textos dos códigos que o servidor devolve em ?erro= na volta do OAuth. Código desconhecido vira a mensagem genérica
// (nunca exibimos texto livre vindo da URL).
const MESSAGES: Record<string, string> = {
  autorizacao_invalida: 'Autorização inválida. Tente conectar de novo.',
  sessao: 'Entre na sua conta do Seu Impulso neste navegador e tente conectar de novo.',
  expirada: 'Este pedido de autorização expirou ou já foi usado. Tente conectar de novo.',
  cancelada: 'Você cancelou a autorização. Nada foi conectado.',
  nao_concluida: 'A autorização não foi concluída. Tente de novo.',
  sem_contas: 'Não encontramos nenhuma conta de anúncios nesta autorização. Confira se você tem acesso a uma conta de anúncios e tente de novo.',
  link_expirado: 'Este link de conexão expirou ou já foi usado.',
  nao_salvou: 'Não foi possível salvar a autorização. Tente de novo.',
  conta_em_uso: 'Esta conta de anúncios já está conectada em outra empresa ou nesta conta do Seu Impulso. Desconecte lá antes de conectar aqui.',
  permissao: 'A plataforma não liberou o acesso. Conecte de novo e aceite todas as permissões pedidas. Na OpenAI Ads, confira se a chave de API está correta e ativa.',
  plataforma_instavel: 'A plataforma de anúncios está instável agora. Tente conectar de novo em alguns minutos.',
}

export const oauthErrorMessage = (code: string | null): string | null =>
  code ? MESSAGES[code] ?? 'Não foi possível concluir a conexão. Tente de novo.' : null
